export const initialState = {
  cartList: [],
  isLoading: false,
  isDeleting: false,
  deletedLength: 0
};

const cartReducers = (state = initialState, action) => {
  if (action.type === 'CART_GET_CART_LIST_REQUEST') {
    return {
      ...state,
      cartList: [],
      isLoading: true
    };
  }

  if (action.type === 'CART_GET_CART_LIST_SUCCESS') {
    return {
      ...state,
      cartList: action.data,
      isLoading: false
    };
  }

  if (action.type === 'CART_GET_CART_LIST_FAILURE') {
    return {
      ...state,
      cartList: [],
      isLoading: false
    };
  }

  if (action.type === 'CART_DELETE_CARTS_REQUEST') {
    return {
      ...state,
      isDeleting: true
    };
  }

  if (action.type === 'CART_DELETE_CARTS_SUCCESS') {
    return {
      ...state,
      cartList: action.data,
      deletedLength: action.deletedLength,
      isDeleting: false
    };
  }

  if (action.type === 'CART_DELETE_CARTS_FAILURE') {
    return {
      ...state,
      isDeleting: false,
      deletedLength: 0
    };
  }

  return state;
};

export default cartReducers;
